import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Card,
  Typography,
  List,
  ListItem,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  useGetEmployeeScheduleDetailsByMonthQuery,
  useGetPositionQuery,
  useGetTeamQuery,
  useDeleteRescheduleMutation,
  useGetRescheduleOrderByDateQuery,
} from "../../../Api/attoDeskApi";
import {
  IPosition,
  IScheduleListDetails,
  ITeam,
  ScheduleEdit,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { Privileges } from "../../../Core/Enum/enum";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import useUser from "../../../Core/hook/useUser";
import * as XLSX from "xlsx";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import jsPDF from "jspdf";
import "jspdf-autotable";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import NewPopUpTeam from "../../ScheduleList/Edit/scheduleEdit";
import NewPopUpTeamResche from "../../ScheduleList/Create/Reschedule";
import NewPopUpTeamRemove from "../../ScheduleList/Edit/RemovedEdited";
import NewPopUpTeamAdminEdit from "../../ScheduleList/Edit/index";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import RefreshIcon from "@mui/icons-material/Refresh";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import { DateSelectArg, EventClickArg } from "@fullcalendar/core";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import DrawerPopUp from "./drawerPopUp";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const capitalizeFirstLetter = (name: string) =>
  name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const isMobileRes = useIsMobile();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const { userHasRight } = useUser();
  const [openDrawerPopUP, setOpenDrawerPopUP] = useState(false);
  const [selectedDateDrawerPopUP, setSelectedDateDrawerPopUP] =
    React.useState<Dayjs | null>(dayjs());

  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );

  const [selectedCoursing, setSelectedCoursing] =
    useState<IScheduleListDetails | null>(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [selectedCoursingResche, setSelectedCoursingResche] =
    useState<IScheduleListDetails | null>(null);
  const [openDialogResche, setOpenDialogResche] = useState(false);

  const [selectedCoursingRemove, setSelectedCoursingRemove] =
    useState<IScheduleListDetails | null>(null);
  const [openDialogRemove, setOpenDialogRemove] = useState(false);

  const [selectedCoursingAdminEdit, setSelectedCoursingAdminEdit] =
    useState<ScheduleEdit | null>(null);
  const [openDialogAdminEdit, setOpenDialogAdminEdit] = useState(false);

  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<ScheduleEdit | null>(
    null
  );
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(dayjs());

  const [startDate, setStartDate] = useState<Dayjs>(dayjs().startOf("month"));
  const [endDate, setEndDate] = useState<Dayjs>(dayjs().endOf("month"));

  const { data, isLoading, isError, refetch } =
    useGetEmployeeScheduleDetailsByMonthQuery({
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
    });

  const handleIsBooked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setPaymentMonthYear(dayjs(selectedValue));
  };

  const { data: tenantData, isLoading: tenantIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const {
    data: OrderData,
    isLoading: OrderDataIsLoadig,
    isError: OrderDataIsError,
  } = useGetRescheduleOrderByDateQuery({
    searchText: "",
    startDate: paymentMonthYear.format("YYYY-MM-DD"),
  });

  const teamList = useMemo(() => {
    return tenantData?.data as ITeam[];
  }, [tenantData?.data]);

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const teamMap = useMemo(() => {
    const map = new Map<
      number,
      {
        name: string;
        image: string;
        hourlySalary: string;
        otHourlySalary: string;
        positionName: string | null;
      }
    >();

    teamList?.forEach((teamMember) => {
      const fullName = `${capitalizeFirstLetter(
        teamMember.teamFirstName || ""
      )} ${capitalizeFirstLetter(teamMember.teamLastName || "")}`.trim();
      const positionName = postionMap.get(teamMember.teamPositionId) || null;

      map.set(teamMember.id, {
        name: fullName,
        image: teamMember.teamImg,
        hourlySalary: teamMember.teamHourlySalary,
        otHourlySalary: teamMember.teamOtHourlySalary,
        positionName,
      });
    });

    return map;
  }, [teamList, postionMap]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleDateChange = (newValue: Dayjs | null) => {
    setSelectedDate(newValue);

    if (newValue) {
      const mockEvent = {
        target: {
          value: newValue.format("YYYY-MM-DD"),
        },
      } as React.ChangeEvent<HTMLInputElement>;

      handleIsBooked(mockEvent);
    }
  };

  const goToPreviousDay = () => {
    const prevDay =
      selectedDate?.subtract(1, "day") || dayjs().subtract(1, "day");
    handleDateChange(prevDay);
  };

  const goToToday = () => {
    const today = dayjs();
    handleDateChange(today);
  };

  const goToNextDay = () => {
    const nextDay = selectedDate?.add(1, "day") || dayjs().add(1, "day");
    handleDateChange(nextDay);
  };

  const handleOpenDrawerPopUp = (date: Dayjs) => {
    setOpenDrawerPopUP(true);
    setSelectedDateDrawerPopUP(date);
  };

  const handleCloseDrawerPopUp = () => {
    setOpenDrawerPopUP(false);
    setSelectedDateDrawerPopUP(null);
  };

  const coursings: IScheduleListDetails[] = Array.isArray(data?.data)
    ? (data?.data as IScheduleListDetails[])
    : [];

  const coursingsTwo: ScheduleEdit[] = Array.isArray(OrderData?.data)
    ? (OrderData?.data as ScheduleEdit[])
    : [];

  const handleExportToExcel = () => {
    const exportData = coursings.map((row, index) => ({
      "#": index + 1,
      "Employee Name": teamMap.get(row.empid)?.name || "",
      Position: teamMap.get(row.empid)?.positionName || "",
      "Schedule ": `${formatTime(row.schedule?.startTime)} - ${formatTime(
        row.schedule?.endTime
      )}${row.schedule?.spansNextDay == true ? " [next day]" : ""} ${
        row.schedule && row.schedule.schedule_end_date
          ? row.schedule.status === "deleted"
            ? " [D]"
            : row.schedule.schedule_end_date &&
              row.schedule.status === "updated"
            ? " [Up]"
            : ""
          : ""
      }`,

      Status: row.isReSchedules ? "Modified" : "Usual",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ScheduleList");
    const paymentMonthYearPrint =
      dayjs(paymentMonthYear).format("YYYY MMM, DD");
    const fileName = `ScheduleList_${paymentMonthYearPrint}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleExportToPDF = () => {
    const tableData = coursings.map((row, index) => [
      index + 1,
      teamMap.get(row.empid)?.name || "",
      teamMap.get(row.empid)?.positionName || "",
      formatTime(row.schedule?.startTime) +
        " - " +
        formatTime(row.schedule?.endTime) +
        (row.schedule?.spansNextDay ? " [next day]" : "") +
        (row.schedule && row.schedule.schedule_end_date
          ? row.schedule.status === "deleted"
            ? " [D]"
            : row.schedule.schedule_end_date &&
              row.schedule.status === "updated"
            ? " [Up]"
            : ""
          : ""),
      row.isReSchedules ? "Modified" : "Usual",
    ]);

    const tableHeaders = [
      ["#", "Employee Name", "Position", "Schedule ", "Status"],
    ];

    const currentMonth = dayjs().format("YYYY MMM, DD");

    const paymentMonthYearPrint =
      dayjs(paymentMonthYear).format("YYYY MMM, DD");

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = companyLogo;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = logowidthPrint;
    const imgHeight = 10;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 15;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Schedule List`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Date: ${paymentMonthYearPrint}`, textStartY + 5);

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `ScheduleList_${paymentMonthYearPrint}.pdf`;

      doc.save(fileName);
    };
  };

  const handleOpenDeletePopup = (coursingsTwo: ScheduleEdit) => {
    setCoursingToDelete(coursingsTwo);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteRescheduleMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the schedule");
    }
  };

  const handleOpenDialog = (coursing: IScheduleListDetails) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
    refetch();
  };

  const handleOpenDialogResche = (coursing: IScheduleListDetails) => {
    setSelectedCoursingResche(coursing);
    setOpenDialogResche(true);
  };

  const handleCloseDialogResche = () => {
    setSelectedCoursingResche(null);
    setOpenDialogResche(false);
    refetch();
  };

  const handleOpenDialogRemove = (coursing: IScheduleListDetails) => {
    setSelectedCoursingRemove(coursing);
    setOpenDialogRemove(true);
  };

  const handleCloseDialogRemove = () => {
    setSelectedCoursingRemove(null);
    setOpenDialogRemove(false);
    refetch();
  };

  const handleOpenDialogAdminEdit = (coursingsTwo: ScheduleEdit) => {
    setSelectedCoursingAdminEdit(coursingsTwo);
    setOpenDialogAdminEdit(true);
  };

  const handleCloseDialogAdminEdit = () => {
    setSelectedCoursingAdminEdit(null);
    setOpenDialogAdminEdit(false);
    refetch();
  };

  const handleAddProductClick = () => {
    // navigate("/re-Schedule/create");
    navigate(
      `/re-Schedule/create?date=${paymentMonthYear.format("YYYY-MM-DD")}`
    );
  };
  const handleAddReschedule = () => {
    navigate(`/re-Schedule/list`);
  };

  const handleAddweeklyReport = () => {
    navigate(`/attendance/weekly/report`);
  };

  if (isLoading || tenantIsLoading || positionLoading || OrderDataIsLoadig)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card
            className={classes.card}
            sx={{
              minHeight: "100vh",
            }}
          >
            {isMobileRes ? (
              <Grid
                container
                justifyContent={"space-between"}
                spacing={2}
                sx={{ borderBottom: 4, padding: 2, pt: 3 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-start"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      alignContent: "center",
                    }}
                  >
                    <Grid item>
                      <Typography className={classes.cardTitle}>
                        Schedule List
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        startIcon={<TableViewIcon />}
                        className={classes.addButtonPdfExcel}
                        onClick={handleExportToExcel}
                      >
                        Excel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        startIcon={<LocalPrintshopSharpIcon />}
                        className={classes.addButtonPdfExcel}
                        onClick={handleExportToPDF}
                      >
                        pdf
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{
                      display: "flex",
                      justifyContent: {
                        xs: "flex-end",
                        md: "flex-end",
                      },
                    }}
                  >
                    <Grid item>
                      <Link
                        to={`/attendance/weekly/report`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddweeklyReport}
                        >
                          Weekly Report
                        </Button>
                      </Link>
                    </Grid>
                    <Grid item>
                      <Link
                        to={`/re-Schedule/create?date=${paymentMonthYear.format(
                          "YYYY-MM-DD"
                        )}`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddProductClick}
                        >
                          Add New
                        </Button>
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 4, padding: 2, pt: 4 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-start"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      alignContent: "center",
                    }}
                  >
                    <Grid item>
                      <Typography className={classes.cardTitle}>
                        Schedule List
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={8}
                  md={8}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{
                      display: "flex",
                      justifyContent: {
                        xs: "flex-start",
                        md: "flex-end",
                      },
                    }}
                  >
                    <Grid item>
                      <Link
                        to={`/attendance/weekly/report`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddweeklyReport}
                        >
                          Weekly Report
                        </Button>
                      </Link>
                    </Grid>
                    <Grid item>
                      <Link
                        to={`/re-Schedule/create?date=${paymentMonthYear.format(
                          "YYYY-MM-DD"
                        )}`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddProductClick}
                        >
                          Add New
                        </Button>
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid container spacing={2} pt={2}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                m={2}
                pt={4}
                sx={{
                  minHeight: "100vh",
                }}
              >
                <FullCalendar
                  plugins={[dayGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  events={coursings.map((row, index) => {
                    const startTime = row.schedule?.startTime;
                    const endTime = row.schedule?.endTime;
                    const date = row.date;
                    const schedulTimeSlot = `${formatTime(
                      startTime
                    )} - ${formatTime(endTime)}`;
                    let title = formatTime(endTime); // Show end time first in title
                    let subtitle = `${formatTime(startTime)} - ${formatTime(
                      endTime
                    )}`; // Show time range in subtitle

                    if (row.schedule?.spansNextDay) {
                      title += " [next day]";
                      subtitle += " [next day]";
                    }

                    if (row.schedule?.schedule_end_date) {
                      if (row.schedule.status === "deleted") {
                        title += " [D]";
                        subtitle += " [D]";
                      } else if (row.schedule.status === "updated") {
                        title += " [Up]";
                        subtitle += " [Up]";
                      }
                    }

                    if (row.empid) {
                      const empName = teamMap.get(row.empid)?.name || "";
                      title += ` ${empName}`;
                      subtitle += ` ${empName}`;
                    }

                    return {
                      id: String(index),
                      title,
                      start: `${dayjs(date).format("YYYY-MM-DD")}T${startTime}`,
                      end: `${dayjs(date).format("YYYY-MM-DD")}T${endTime}`,
                      // backgroundColor:
                      //   row.schedule?.status === "deleted"
                      //     ? "#f8d7da"
                      //     : row.schedule?.status === "updated"
                      //     ? "#fff3cd"
                      //     : "#d1ecf1",
                      // borderColor:
                      //   row.schedule?.status === "deleted"
                      //     ? "#f5c6cb"
                      //     : row.schedule?.status === "updated"
                      //     ? "#ffeeba"
                      //     : "#bee5eb",
                      // textColor:
                      //   row.schedule?.status === "deleted"
                      //     ? "#721c24"
                      //     : row.schedule?.status === "updated"
                      //     ? "#856404"
                      //     : "#0c5460",
                      backgroundColor:
                        row.schedule?.status === "deleted"
                          ? "#f8d7da"
                          : row.isReSchedules
                          ? "#fff3cd"
                          : "#d1ecf1",

                      borderColor:
                        row.schedule?.status === "deleted"
                          ? "#f5c6cb"
                          : row.isReSchedules
                          ? "#ffeeba"
                          : "#bee5eb",

                      textColor:
                        row.schedule?.status === "deleted"
                          ? "#721c24"
                          : row.isReSchedules
                          ? "#856404"
                          : "#0c5460",

                      display: "block",
                      extendedProps: {
                        empid: row.empid,
                        subtitle: subtitle,
                        isReSchedules: row.isReSchedules,
                        scheduleStatus: row.schedule?.status,
                        spansNextDay: row.schedule?.spansNextDay,
                        meeting_time: row.schedule?.startTime || "",
                        meeting_Date: row.date || "",
                        schedule_end_date:
                          row.schedule?.schedule_end_date || "",
                        schedulTimeSlot: schedulTimeSlot || "",
                      },
                    };
                  })}
                  eventContent={(eventInfo) => {
                    const {
                      empid,
                      isReSchedules,
                      scheduleStatus,
                      spansNextDay,
                      meeting_time,
                      meeting_Date,
                      subtitle,
                      schedule_end_date,
                      schedulTimeSlot,
                    } = eventInfo.event.extendedProps;

                    const displayTitle =
                      eventInfo.event.title.length > 20
                        ? eventInfo.event.title.slice(0, 20) + "..."
                        : eventInfo.event.title;

                    return (
                      <Tooltip
                        placement="top"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#f9f9f9",
                              color: "#333",
                              border: "1px solid #ccc",
                              borderRadius: 2,
                              boxShadow: 3,
                              padding: 1.5,
                              maxWidth: 500,
                            },
                          },
                          arrow: {
                            sx: {
                              color: "#f9f9f9",
                            },
                          },
                        }}
                        title={
                          <Grid container spacing={1}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography
                                fontWeight="bold"
                                fontSize={14}
                                color="#0d47a1"
                              >
                                {subtitle || displayTitle}
                              </Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} ml={3}>
                              {meeting_Date && (
                                <Typography fontSize={13}>
                                  <strong>Date:</strong>{" "}
                                  {dayjs(meeting_Date).format("MMM DD, YYYY")}
                                </Typography>
                              )}
                              {schedulTimeSlot && (
                                <Typography fontSize={13}>
                                  <strong>Schedule Time:</strong>{" "}
                                  {schedulTimeSlot}
                                </Typography>
                              )}
                              {empid && (
                                <Typography fontSize={13}>
                                  <strong>Staff:</strong>{" "}
                                  {teamMap.get(empid)?.name || ""}
                                </Typography>
                              )}
                              {isReSchedules === true && (
                                <Typography
                                  textAlign="right"
                                  sx={{
                                    color: "#1976d2",
                                    fontWeight: 600,
                                    lineHeight: 1.5,
                                    fontSize: "0.875rem",
                                    paddingLeft: "1px",
                                    fontStyle: "italic",
                                  }}
                                >
                                  -- Reschedule
                                </Typography>
                              )}
                              {schedule_end_date &&
                                (scheduleStatus === "deleted" ||
                                  scheduleStatus === "updated") && (
                                  <Typography
                                    textAlign="right"
                                    sx={{
                                      color:
                                        scheduleStatus === "deleted"
                                          ? "#d32f2f"
                                          : scheduleStatus === "updated"
                                          ? "#1976d2"
                                          : "#000",
                                      fontWeight: 600,
                                      lineHeight: 1.5,
                                      fontSize: "0.875rem",
                                      paddingLeft: "1px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {schedule_end_date && (
                                      <>
                                        -- Previous time slot{" "}
                                        {scheduleStatus === "deleted"
                                          ? "(deleted on "
                                          : scheduleStatus === "updated"
                                          ? "(updated on "
                                          : "("}
                                        {dayjs(schedule_end_date).format(
                                          "MMM D, YYYY h:mm A"
                                        )}
                                        {")"} --
                                      </>
                                    )}
                                  </Typography>
                                )}
                            </Grid>
                          </Grid>
                        }
                      >
                        <div
                          style={{
                            marginBottom: "6px",
                            borderRadius: "4px",
                            padding: "4px 8px",
                            backgroundColor: eventInfo.backgroundColor,
                            color: eventInfo.textColor,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                            // gap: 3
                          }}
                        >
                          {meeting_time
                            ? `${formatTime(meeting_time)} - ${displayTitle}`
                            : displayTitle}
                        </div>
                      </Tooltip>
                    );
                  }}
                  dateClick={(info: DateClickArg) => {
                    const clickedDate = dayjs(info.dateStr);
                    handleOpenDrawerPopUp(clickedDate);
                  }}
                  eventClick={(info: EventClickArg) => {
                    const clickedDate = dayjs(info.event.start); // or use extendedProps if needed
                    handleOpenDrawerPopUp(clickedDate);
                  }}
                  datesSet={(dateInfo) => {
                    const start = dayjs(dateInfo.start).format("YYYY-MM-DD");
                    const end = dayjs(dateInfo.end).format("YYYY-MM-DD");

                    console.log(
                      "Month changed, fetching data from",
                      start,
                      "to",
                      end
                    );
                    setStartDate(dayjs(start));
                    setEndDate(dayjs(end));
                  }}
                  dayCellDidMount={(arg) => {
                    arg.el.style.cursor = "pointer";

                    const cellDate = dayjs(arg.date).format("YYYY-MM-DD");
                  }}
                />
              </Grid>
            </Grid>
          </Card>
        </Grid>
        {openDrawerPopUP && selectedDateDrawerPopUP && (
          <DrawerPopUp
            openModel={openDrawerPopUP}
            handleCloseDialogPopUp={handleCloseDrawerPopUp}
            paymentMonthYearDate={selectedDateDrawerPopUP}
          />
        )}
      </Grid>
    </div>
  );
};

export default Index;
